import * as React from 'react';
import { HeightAnimation } from '../height/height';
import { namespacedClassnames } from '../../common/namespace-classes';
export var SlideAnimation = function (props) {
    var animationClass = 'slide';
    var showOrHide = props.show ? 'show' : 'hide';
    var classNames = namespacedClassnames(animationClass, showOrHide);
    return (React.createElement(HeightAnimation, { show: props.show },
        React.createElement("div", { className: classNames }, props.children)));
};
//# sourceMappingURL=slide.js.map